import React, { Component } from 'react';
import {externalLinks} from "../helper";

export class Imprint extends Component {
  render() {
    return (
      <div className="container-fluid mb-5 About">

        <div className="lead border-bottom px-2 pb-1 redactor" dangerouslySetInnerHTML={{__html:externalLinks(this.props.data.imprint)}} />

      </div>
    );
  }
}
